import React from 'react';
import { useUser, useClerk } from '@clerk/clerk-react';

// Reusable gating wrapper for buttons that require sign-in.
// When signed out: shows a 🔒 prefix, tooltip, and click opens Clerk's sign-in modal.
// When signed in: passes through to the supplied onClick.
// Props mirror a regular <button> so it can drop into existing markup with minimal changes.
export default function GatedButton({
  children,
  onClick,
  style,
  title,
  lockedHint = 'Sign in to use this feature',
  // onMouseEnter/onMouseLeave forwarded so callers can keep their hover effects
  onMouseEnter,
  onMouseLeave,
  ...rest
}) {
  const { isSignedIn, isLoaded } = useUser();
  const { openSignIn } = useClerk();

  // While Clerk is still loading session info, treat as locked (safer default)
  const locked = !isLoaded || !isSignedIn;

  const handleClick = (e) => {
    if (locked) {
      e.preventDefault();
      openSignIn();  // Opens Clerk's modal — no redirect, keeps user in context
      return;
    }
    onClick?.(e);
  };

  return (
    <button
      {...rest}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      title={locked ? lockedHint : title}
      style={style}
    >
      {/* Lock icon only renders when locked; spacing built in so caller styles stay clean */}
      {locked && <span style={{ marginRight: 4, fontSize: '0.9em', opacity: 0.85 }}>🔒</span>}
      {children}
    </button>
  );
}
